export enum SimpleTableRowStyle {
    None = "None",
    Link = "Link",
    Image = "Image",
    Checkbox = "Checkbox",
    Emoji = "Emoji",
    PushScreen = "PushScreen",
}
